import { io, Socket } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'https://ws.fnb-hub.com';

let socket: Socket | null = null;
let _registerHandler: (() => void) | null = null;

/**
 * Khởi tạo & trả về singleton Socket instance.
 * Chỉ connect 1 lần duy nhất.
 */
export function getSocket(): Socket {
  if (!socket) {
    socket = io(SOCKET_URL, {
      transports: ['websocket'],
      autoConnect: false,
      reconnectionAttempts: 5,
      reconnection: true,
      timeout: 5000,
    });

    socket.on('connect_error', (err) => {
      console.warn('[Socket] Connection error:', err.message);
    });
  }
  return socket;
}

/** Kết nối socket và register userId */
export function connectSocket(userId: string) {
  try {
    const s = getSocket();

    // Xóa handler register cũ (nếu có)
    if (_registerHandler) {
      s.off('connect', _registerHandler);
    }

    _registerHandler = () => {
      console.log('[Socket] Connected:', s.id);
      s.emit('register', { userId });
    };

    s.on('connect', _registerHandler);

    if (!s.connected) {
      s.connect();
    } else {
      s.emit('register', { userId });
    }
  } catch (err) {
    console.warn('[Socket] Failed to connect:', err);
  }
}

/** Ngắt kết nối socket (khi logout) */
export function disconnectSocket() {
  if (socket) {
    try {
      socket.disconnect();
    } catch {
      // Ignore disconnect errors
    }
  }
}
